import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

// Contrôle Klarys en 8 points d'une preuve de virement (✔ / ✖ + motif)
export const ControlesVirement = ({ preuve }) => {
  const controles = preuve.controles || [];
  if (!controles.length) return null;
  const score = preuve.score ?? Math.round((controles.filter((c) => c.ok).length * 100) / controles.length);
  const cls = score === 100 ? 'text-emerald-700 bg-emerald-50 border-emerald-200' : score >= 75 ? 'text-amber-800 bg-amber-50 border-amber-200' : 'text-red-700 bg-red-50 border-red-200';
  return (
    <div className="mt-1 mb-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-[11px]" data-testid={`preuve-controles-${preuve.id}`}>
      <div className="mb-1.5 flex items-center justify-between">
        <span className="font-semibold uppercase tracking-wide text-slate-600">Contrôle Klarys — {controles.length} points</span>
        <span className={`rounded-full border px-2 py-0.5 font-bold ${cls}`} data-testid={`preuve-score-${preuve.id}`}>Score {score} %</span>
      </div>
      <ul className="grid gap-1 sm:grid-cols-2">
        {controles.map((c) => (
          <li key={c.code} className="flex items-start gap-1.5" data-testid={`preuve-controle-${preuve.id}-${c.code}`}>
            {c.ok ? <CheckCircle2 className="mt-px h-3.5 w-3.5 shrink-0 text-emerald-600" /> : <XCircle className="mt-px h-3.5 w-3.5 shrink-0 text-red-600" />}
            <span><span className="font-semibold text-slate-800">{c.libelle}</span>{c.detail ? <span className="text-slate-500"> — {c.detail}</span> : null}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
